// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VCalendar from 'v-calendar';
import VueTablerIcons from "vue-tabler-icons";
import './assets/css/config.css'
import './assets/css/main.css'

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import setupInterceptors from './services/setupInterceptors';

Vue.config.productionTip = false

// Make BootstrapVue available throughout project
Vue.use(BootstrapVue)

// Lib utlisée pour les icones
// Version 1.* (compatible avec Vue 2)
// Icones : https://tabler-icons.io/
// Documentation lib : https://github.com/alex-oleshkevich/vue-tabler-icons
Vue.use(VueTablerIcons);

setupInterceptors(store, router)

Vue.use(VCalendar, {
  componentPrefix: 'vc'  // Use <vc-calendar /> instead of <v-calendar />
});

//Sentry
Sentry.init({
  Vue,
  dsn: "https://7128cb33a5be4ad9a36c47dc12782a79@o493491.ingest.sentry.io/6273124",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["http://preprod-clinique-nac.bleu122.com/", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js